<template>
  <div class="article-container">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="article-content">
      <h1 class="article-title">{{title}}</h1>

      <div class="article-meta">
        <!-- <span class="article-source" v-if="reource">来源： {{reource}} · </span> -->
        <span class="article-date">{{pushTime}}</span>
        <el-button type="primary" @click="downloadFile" v-if="isLogin">下载</el-button>
        <el-button type="primary" @click="downloadFile" v-if="!isLogin">登录下载</el-button>
        <div class="article-divider" />
      </div>

      <div v-if="content" class="article-body" v-html="content" />
      <div v-else class="article-empty">未加载到文章内容</div>
    </div>
  </div>
</template>

<script>
import resultsService from '@/service/results.service.js'

export default {
  data() {
    return {
      channelCode: 'home',
      sysCode: 'ceggrc-web-2025',
      title: "",
      reource: "",
      number: 0,
      pushTime: "",
      content: "",
      staticFilePrePath: '/cms_static_files/home/sys_home_pc/',
      staticHtml: '',
      titleShort: '',
      isLogin: localStorage.getItem('userCode') ? true : false,
    }
  },
  mounted() {
    let query = this.$route.query;
    let sectionCode = query.sectionCode;
    let articleCode = query.articleCode;
    this.loadDttail(sectionCode, articleCode);
  },
  methods:{
    loadPage(staticFileName) {
      let self = this;
      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
          if(this.responseText) {
            self.staticHtml = this.responseText;
          }
        }
      };
      let hsot = window.location.protocol+'//'+window.location.host;
      xhttp.open("GET", hsot+staticFileName, true);
      xhttp.send();
    },
    loadDttail(sectionCode, articleCode) {
      let channelCode = this.channelCode;
      let sysCode = this.sysCode;
      let params = "/" + channelCode + "/" + sysCode + "/" + sectionCode + "/" + articleCode;
      resultsService.getArticleDetail(params)
        .then(res => {
          if(res.data.code == '0000' && res.data.data) {
            let newData = res.data.data;
            this.title = newData.title;
            this.reource = newData.source;
            this.number = newData.nums;
            this.pushTime = newData.publishTime;
            this.content = newData.content;
            this.titleShort = newData.titleShort;
            // let staticFileName = newData.staticFileName?this.staticFilePrePath+newData.staticFileName:'';
            // if(staticFileName) { this.loadPage(staticFileName); }
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          console.error(error);
          this.$message.error("系统错误, 请稍后刷新重试");
        });
    },
     // 下载文件
    async downloadFile() {
      if(!localStorage.getItem('userCode')) {
        this.$message.warning('请登录后下载');
        return;
      }
      try {
        let fileId = this.titleShort.split('|')[0];
        let fileName = this.titleShort.split('|')[1];
        await resultsService.downloadFile(fileId,fileName);
        this.sendLog(fileName);
      } catch (error) {
        console.error('下载失败:', error);
      }
    },
    async sendLog(fileName) {
        let obj = {
          "businessType": '下载',//业务名称 
          "businessTypeCode":'download',//  业务编码 
          "channelCode": "home",//渠道编码（大平台渠道编码）
          "client": "中国企业走出去",//客户端类型（用户中心）
          "clientCode": "ceggrc-web-2025",// 客户端编码 
          "operationContent": fileName, //业务内容
          "operationType": '下载', //操作类型类型,渠道自定
          "operationTypeCode": 'download',// 操作类型编码,渠道自定 
          "userCode": localStorage.getItem('userCode') ?localStorage.getItem('userCode') : '',//用户编码（用户中心编码）
          "userIp": '',//用户ip
          "userName": localStorage.getItem('userName') ? localStorage.getItem('userName') : ''//用户名称（用户中心）
        };
        await resultsService.sendRecord(obj);
    }
  }
}
</script>

<style scoped>
.article-container {
  margin: 0 auto;
  max-width: 800px;
  width: 100%;
  margin-top: 90px;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
}

.breadcrumb {
  margin-bottom: 20px;
}

.article-content {
  width: 100%;
}

.article-title {
  width: 100%;
  font-size: 24px;
  font-weight: 500;
  color: black;
  margin-bottom: 35px;
  line-height: 1.4;
  word-break: break-word;
}

.article-meta {
  width: 100%;
  margin-bottom: 25px;
  padding-bottom: 20px;
  font-size: 14px;
  border-bottom: 1px solid #fcdbd1;
  position: relative;
  display: flex;
  justify-content: space-between;
}

.article-source {
  color: #666;
}

.article-date {
  color: #666;
}

.article-divider {
  width: 30px;
  height: 5px;
  background-color: #fd4813;
  position: absolute;
  bottom: -5px;
  left: 0;
}

.article-body {
  width: 100%;
  line-height: 1.8;
  font-size: 16px;
  color: #333;
}

.article-body img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 15px auto;
}

.article-body p {
  margin-bottom: 15px;
}

.article-empty {
  text-align: center;
  padding: 40px 0;
  color: #999;
  font-size: 16px;
}

/* 响应式样式 */
@media (max-width: 900px) {
  .article-container {
    max-width: 100%;
    padding: 15px;
    margin-top: 70px;
  }
}

@media (max-width: 767px) {
  .article-title {
    font-size: 20px;
    margin-bottom: 20px;
  }
  
  .article-meta {
    margin-bottom: 20px;
    padding-bottom: 15px;
  }
  
  .article-body {
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .article-container {
    margin-top: 60px;
    padding: 10px;
  }
  
  .breadcrumb {
    margin-bottom: 15px;
    font-size: 12px;
  }
  
  .article-title {
    font-size: 18px;
    margin-bottom: 15px;
  }
  
  .article-meta {
    font-size: 12px;
  }
  
  .article-body {
    font-size: 14px;
    line-height: 1.6;
  }
}
</style>
